module.exports = __webpack_public_path__ + "img/04.cec8587b.jpg";